<template>
  <header class="navHeader">
    <div>
      <div :disabled="!allowPrev">
        <template v-if="prev" >
          <router-link :to="{ name: 'negociejaApp', params: { session: session, step: prev.slug }}">
            <fa :icon="['far', 'arrow-left']" />
          </router-link>
          <p>{{ prev.title }}</p>
        </template>
      </div>
      <div>
        <h3>{{ step }}</h3>
      </div>
      <div :disabled="!allowNext">
        <template v-if="next">
          <router-link :to="{ name: 'negociejaApp', params: { session: session, step: next.slug }}">
            <fa :icon="['far', 'arrow-right']" />
          </router-link>
          <p>{{ next.title }}</p>
        </template>
      </div>
    </div>
    <p>{{ text }}</p>
  </header>
</template>

<script>
export default {
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    },
    prev: {
      type: Object
    },
    next: {
      type: Object
    },
    msg: {
      type: String
    }
  },
  watch: {
    msg ( value ) {
      this.text = value
    }
  },
  data () {
    return {
      allowNext: false,
      allowPrev: false,
      text: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .navHeader {
    display: block;
    width: 100%;
    padding: 0 40px;
    height: 95px;
    
    > div {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      > div {
        flex: 1;
        padding: 0;

        &[disabled] {
          opacity: .5;
          pointer-events: none;
        }
        &:first-child {
          padding-top: $hmg_mini;
        }
        &:last-child {
          text-align: right;
          padding-top: $hmg_mini;
        }
      }
      h3 {
        text-align: center;
        color: $azul-escuro;
      }

      a {
        color: $preto-2;

        
      }
      p {
        color: $preto-2;
        padding: 0; margin: $hmg_mini 0;
      }
    }
    
    >p {
      text-align: center;
      margin-top: $hmg_mid;
      color: $preto-2
    }
  }
</style>